import { render } from "./batch_on_off.vue?vue&type=template&id=ddfa2598&scoped=true"
import script from "./batch_on_off.vue?vue&type=script&lang=js"
export * from "./batch_on_off.vue?vue&type=script&lang=js"

import "./batch_on_off.vue?vue&type=style&index=0&id=ddfa2598&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddfa2598"]])

export default __exports__